// Pure decision for WHEN to create the flyover Mapbox map, extracted from FlyoverPreview so it can be
// unit-tested without mounting the map component. The map must not be built until the fullscreen modal
// has finished opening: building it against a not-yet-sized container makes Mapbox fall back to a
// 400x300 default canvas pinned top-left, which is what made the flyover start "in a corner".
export type FlyoverMapInitAction =
  | "skip" // already initialised — do nothing
  | "init" // modal is open and sized — create the map now
  | "defer"; // modal still opening — wait for the `shown.bs.modal` event, then create the map

/**
 * Decide how `initializeMapWhenReady()` should proceed given the current state.
 * @param mapInitialized whether the map has already been created for this open.
 * @param modalShown whether the fullscreen modal has finished its open transition (container sized).
 */
export function resolveFlyoverMapInit(
  mapInitialized: boolean,
  modalShown: boolean
): FlyoverMapInitAction {
  if (mapInitialized) return "skip";
  return modalShown ? "init" : "defer";
}
